'use strict';

import $ from 'jquery';
import Mustache from 'mustache';

/**
 * This module handles rendering templates
 * - Fetching the correct template
 * - Handling possible subtemplates
 * - Rendering
 */
const templateHelper = {
  _selectorPrefix: '#mustache-',

  /**
   * Get template from DOM
   *
   * @param  {string} name  The name of the template
   * @return {string}       The template code
   */
  _getTemplate: function(name) {
    return $(this._selectorPrefix + name).html();
  },

  /**
   * Render template
   *
   * @param {string}  templateName The name of the template to use for rendering
   * @param {object}  data         Data to use
   * @param {jQuery}  $parent      jQuery-object of the parent element to which the data is inserted
   * @param {string}  placement    Where to place new html.
   *                               - 'replace' replaces parent html with new html
   *                               - 'append' appends new html as the last child of the parent
   *                               - 'prepend' prepends new html as the first child of the parent
   *                               If false, prepends new html to parent. Default is true.
   */
  render: function(templateName, data, $parent, placement) {
    // TODO: fetch all templates to a subtemplate object and pass that to Mustache.render as third param
    // For now this has not been needed though. Implement when it becomes necessary.

    if (typeof placement !== 'string') {
      placement = 'replace';
    }

    switch (placement) {
    case 'replace':
      $parent.html(Mustache.render(this._getTemplate(templateName), data));
      break;
    case 'append':
      $parent.append(Mustache.render(this._getTemplate(templateName), data));
      break;
    case 'prepend':
      $parent.prepend(Mustache.render(this._getTemplate(templateName), data));
      break;
    }
  }
};

module.exports = templateHelper;
